"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("../style/index.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helper = require("./tools/helper");

var _BaywatchClient = _interopRequireDefault(require("./clients/BaywatchClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WatchComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WatchComponent, _React$Component);

  function WatchComponent(props) {
    var _this;

    _classCallCheck(this, WatchComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WatchComponent).call(this, props));
    _this.baywatchClient = new _BaywatchClient.default(_this.props.accessToken);
    _this.mounted = false;
    _this.state = {
      loading: true,
      userIsSetup: false,
      error: false,
      subscriptionIsActive: false
    };
    return _this;
  }

  _createClass(WatchComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      clearInterval(this.refreshInterval);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.accessToken !== this.props.accessToken || prevProps.resourceUri !== this.props.resourceUri) {
        this.baywatchClient = new _BaywatchClient.default(this.props.accessToken);
        this.refreshUserState(this.props, false);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.refreshUserState(this.props, false);
      this.refreshInterval = setInterval(function () {
        return _this2.refreshUserState(_this2.props, true);
      }, this.props.refreshInterval * 1000);
    }
  }, {
    key: "refreshUserState",
    value: function refreshUserState(props, silent) {
      var _this3 = this;

      this.safeSetState({
        loading: !silent
      });
      var sub = (0, _helper.getSubFromJWT)(props.accessToken);
      return Promise.all([this.baywatchClient.checkIfSubscriptionIsSetup(sub, props.resourceUri), this.baywatchClient.checkIfUserIsAlreadySetup(sub)]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            subscribtionIsActive = _ref2[0],
            userIsSetup = _ref2[1];

        var newState = {
          userIsSetup: userIsSetup,
          subscriptionIsActive: subscribtionIsActive,
          error: false
        };

        if (!silent) {
          newState.loading = false;
        }

        _this3.safeSetState(newState);
      }).catch(function () {
        return _this3.safeSetState({
          loading: false,
          error: true
        });
      });
    }
  }, {
    key: "popout",
    value: function popout(url, title) {
      var myWidth = 400;
      var myHeight = 600;
      var left = (screen.width - myWidth) / 2;
      var top = (screen.height - myHeight) / 4;
      return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
    }
  }, {
    key: "popoutAuthorization",
    value: function popoutAuthorization() {
      return this.popout('https://cimpress.auth0.com/authorize?\n' + 'audience=https://api.cimpress.io/&\n' + 'scope=offline_access&\n' + 'response_type=code&\n' + 'client_id=RsGn87z1NMkcG2ZfYyCTpnc9xxn6RVFU&\n' + 'redirect_uri=https://baywatch.trdlnk.cimpress.io/v0/users/authorization&\n' + 'state=' + (0, _helper.getSubFromJWT)(this.props.accessToken), 'Baywatch Subscription');
    }
  }, {
    key: "safeSetState",
    value: function safeSetState(stateChange) {
      if (this.mounted) {
        return this.setState(stateChange);
      }

      return null;
    }
  }, {
    key: "toggleWatchClick",
    value: function toggleWatchClick(resourceUrl) {
      var _this4 = this;

      clearInterval(this.refreshInterval);
      var sub = (0, _helper.getSubFromJWT)(this.props.accessToken);

      var toggleSubscription = function toggleSubscription() {
        _this4.safeSetState({
          loading: true
        });

        _this4.baywatchClient.setSubscription(sub, resourceUrl, !_this4.state.subscriptionIsActive).catch(function () {}).then(function () {
          return _this4.refreshUserState(_this4.props, false);
        }).then(function () {
          _this4.refreshInterval = setInterval(function () {
            return _this4.refreshUserState(_this4.props, true);
          }, _this4.props.refreshInterval * 1000);
        });
      };

      if (this.state.userIsSetup === false) {
        var popup = this.popoutAuthorization();
        this.popupCheckerInterval = setInterval(function () {
          if (popup.closed) {
            clearInterval(_this4.popupCheckerInterval);
            toggleSubscription(false);
          }
        }, 500);
      } else {
        toggleSubscription();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (this.state.error === true) {
        return _react.default.createElement("span", {
          className: 'rcw-main'
        }, this.props.renderOnError());
      }

      if (this.state.loading === true) {
        return _react.default.createElement("span", {
          className: 'rcw-main'
        }, this.props.renderOnRunning());
      }

      if (this.props.addClickHandler) {
        return _react.default.createElement("span", {
          className: 'rcw-main',
          onClick: function onClick() {
            return _this5.toggleWatchClick(_this5.props.resourceUri);
          }
        }, this.props.renderDefault(this.state.subscriptionIsActive));
      }

      return _react.default.createElement("span", {
        className: 'rcw-main'
      }, this.props.renderDefault(this.state.subscriptionIsActive, function () {
        return _this5.toggleWatchClick(_this5.props.resourceUri);
      }));
    }
  }]);

  return WatchComponent;
}(_react.default.Component);

WatchComponent.propTypes = {
  accessToken: _propTypes.default.string.isRequired,
  resourceUri: _propTypes.default.string.isRequired,
  refreshInterval: _propTypes.default.number,
  renderOnError: _propTypes.default.func.isRequired,
  renderOnRunning: _propTypes.default.func.isRequired,
  renderDefault: _propTypes.default.func.isRequired,
  addClickHandler: _propTypes.default.bool
};
WatchComponent.defaultProps = {
  refreshInterval: 60,
  addClickHandler: true
};
var _default = WatchComponent;
exports.default = _default;